export default {
  presenter: 'pulec',
  title: 'SSHáčkem paralelně (cssh, pssh, pdsh, dsh, ...)',
  subtitle: 'začátečníci',
  text: `
Představím možnost, jak pracovat na více zařízeních přes SSH zároveň. Existuje k tomu řada
nástrojů, každý má své výhody a nevýhody. Obzvláště CSSH, které každé SSH sezení otevírá ve
vlastním okně, je vhodný pro práci, kdy každý server může vyžadovat mírně odlišný přístup.
Navíc poskytuje standardní výstup jako jste zvyklí z běžného terminálu. Při práci s SSH může
být užitečné používat vhodný ~/.ssh/config. Krátce se o něm zmíním.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/pulec-ssh.js